import { Banner, Link } from '@farol-ds/react'
import {
  PersistentAlertBannerIcon,
  PersistentAlertBannerLink,
} from '@jusbrasil-web/shared-apollo-client/types'
import { Fragment, useEffect, useState } from 'react'

import { usePersistentAlertBannerDispatcher } from '../../hooks'
import { AlertIcon } from '../alert-icon'

interface SubscriptionOverdueProps {
  text?: string | null
  icon?: PersistentAlertBannerIcon | null
  link?: PersistentAlertBannerLink | null
}

export function SubscriptionOverdue(props: SubscriptionOverdueProps) {
  const { sendTopbarEvent, ref } = usePersistentAlertBannerDispatcher<HTMLDivElement>()

  const [isVisible, setIsVisible] = useState(!!props)
  const { icon, text, link } = props ?? {}

  const handleVisibilityChange = (visible: boolean): void => {
    if (!visible) sendTopbarEvent('UnpaidAlertClosed')
    setIsVisible(visible)
  }

  const handleLinkClick = () => {
    sendTopbarEvent('UnpaidAlertClicked')
  }

  useEffect(() => {
    if (isVisible) {
      sendTopbarEvent('UnpaidAlertView')
    }
  }, [isVisible, sendTopbarEvent])

  return (
    <Banner
      ref={ref}
      visible={isVisible}
      defaultVisible={false}
      level="app"
      type="warning"
      onVisibleChange={handleVisibilityChange}
    >
      <Banner.Content>
        <Banner.Title>
          {icon && (
            <Banner.Icon>
              <AlertIcon icon={icon} data-testid="overdue-subscription-icon" />
            </Banner.Icon>
          )}
          {text}
          <Fragment>
            {' '}
            <Link href={link?.url} onClick={handleLinkClick}>
              {link?.label}
            </Link>
          </Fragment>
        </Banner.Title>
      </Banner.Content>
      <Banner.IconClose />
    </Banner>
  )
}
